import AsterHop from "../assets/projects/AsterHosp.png";
import AtlantisAqu from "../assets/projects/AtlantisAqu.png";
import MaisonLgh from "../assets/projects/MaisonLgh.png";
import MedcareHos from "../assets/projects/MedcareHos.png";
import WellthHos from "../assets/projects/WellthHos.png";
import MedicaHealth from "../assets/projects/MedicaHealth.png";
import ReemHosp from "../assets/projects/ReemHosp.png";
import novatech from "../assets/projects/novatech.png";
import careerHub from "../assets/projects/careerHub.png";
import tnvoyage from "../assets/projects/tnvoyage.png";

export const data = [
  {
    id: 1,
    name: "NovaTech",
    image: novatech,
    github: "",
    live: "https://novatech-pied.vercel.app/",
  },
  {
    id: 2,
    name: "Aster Hospital",
    image: AsterHop,
    github: "",
    live: "https://www.asterhospitals.ae/",
  },
  {
    id: 3,
    name: "CareerHub",
    image: careerHub,
    github: "",
    live: "https://career-hub-job-portal-tau.vercel.app",
  },
  {
    id: 4,
    name: "Aquaventure",
    image: AtlantisAqu,
    github: "",
    live: "https://atlantisv2.bluelogic.ai/",
  },
  {
    id: 5,
    name: "TnVoyage",
    image: tnvoyage,
    github: "",
    live: "https://tnvoyage-app.vercel.app/",
  },
  {
    id: 6,
    name: "Medcare Hospital",
    image: MedcareHos,
    github: "",
    live: "https://www.medcare.ae/en",
  },
  {
    id: 7,
    name: "Wellth Hospital",
    image: WellthHos,
    github: "",
    live: "https://wellth.ae/",
  },
  {
    id: 8,
    name: "Medica BeautyCare",
    image: MedicaHealth,
    github: "",
    live: "https://medicagroup.com/beauty-seeker/",
  },
  {
    id: 9,
    name: "Reem Hospital",
    image: ReemHosp,
    github: "",
    live: "https://www.reemhospital.com/",
  },
  {
    id: 8,
    name: "Realestate",
    image: MaisonLgh,
    github: "",
    live: "https://maisonlgh.com/",
  },
];
